import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';

import { Grid, Button, Typography } from '@hbf/dsl';
import { ConversationChat } from '@hbf/icons/custom';
import { IntercomHandler } from 'ha/components.legacy/IntercomHandler';

const useStyles = makeStyles()(theme => ({
  icon: {
    marginBottom: theme.spacing(1),
  },

  title: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

export const ChatNow: React.FC = () => {
  const { classes } = useStyles();
  const { T } = useIntl();

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid item>
        <ConversationChat fontSize="large" className={classes.icon} />
      </Grid>
      <Grid item>
        <Typography.ParagraphTitle className={classes.title}>
          {T('contact.chat_title')}
        </Typography.ParagraphTitle>
      </Grid>
      <Grid item>
        <IntercomHandler>
          {({ show }) => (
            <Button
              color="primary"
              type="submit"
              variant="outlined"
              data-test-locator="Chat Now Button"
              onClick={show}
            >
              {T('contact_us_chat_now')}
            </Button>
          )}
        </IntercomHandler>
      </Grid>
    </Grid>
  );
};
